import { Pipe, PipeTransform } from '@angular/core';
import { DateFormatService } from '@flyfreely-portal-ui/flyfreely';
import moment from 'moment';

@Pipe({
    name: 'formatLocalDateTimeWithUTC'
})
export class FormatLocalDateTimeWithUTCPipe implements PipeTransform {
    constructor(private dateFormatService: DateFormatService) {}

    transform(time: string | Date, timeZone?: string): string {
        if (!time) {
            return null;
        }

        const dateTimeFormat = this.dateFormatService.getDateTimeFormat();

        const localTime =
            timeZone != null
                ? moment(time).tz(timeZone).format(`${dateTimeFormat} zz`)
                : moment(time).format(`${dateTimeFormat} zz`);

        const utc = moment(time).utc().format('YYYY-MM-DD HH:mm');
        return `${localTime} (${utc}Z)`;
    }
}

@Pipe({
    name: 'formatLocalDateTimeWithUTCProtracted'
})
export class FormatLocalDateTimeWithUTCProtractedPipe implements PipeTransform {
    constructor(private dateFormatService: DateFormatService) {}

    transform(time: string | Date, timeZone?: string): string {
        if (!time) {
            return null;
        }

        const dateTimeFormat = this.dateFormatService.getDateTimeFormat();

        const localTime =
            timeZone != null
                ? moment(time).tz(timeZone).format(`${dateTimeFormat} zz`)
                : moment(time).format(`${dateTimeFormat} zz`);

        const utc = moment(time).utc().format('YY-MM-DD HH:mm');
        return `${localTime} (${utc}Z)`;
    }
}
